import { defer } from "@tanstack/react-router";
import {
  loadCoolingRegimeTemperatures,
  type CoolingRegimeTemperatureFilters,
} from "../services/coolingRegimeTemperatureService";
import { mapCoolingRegimeTemperatureDtoArrayToRows } from "../mappers/coolingRegimeTemperatureMapper";
import type { TemperatureRow } from "../mappers/coolingRegimeTemperatureMapper";

export interface CoolingRegimeTemperatureLoaderResult {
  rows: TemperatureRow[];
  totalCount: number;
  error?: string;
}

export async function coolingRegimeTemperatureLoader(
  filters: CoolingRegimeTemperatureFilters,
): Promise<CoolingRegimeTemperatureLoaderResult> {
  const result = await loadCoolingRegimeTemperatures(filters);

  if (result.error) {
    return {
      rows: [],
      totalCount: 0,
      error: result.error,
    };
  }

  const rows = mapCoolingRegimeTemperatureDtoArrayToRows(result.value);

  return {
    rows,
    totalCount: result.value.length,
  };
}

export function createCoolingRegimeTemperatureDeferredLoader(
  filters: CoolingRegimeTemperatureFilters,
) {
  return {
    data: defer(coolingRegimeTemperatureLoader(filters)),
  };
}
